const BaseDomain = 'shiawan.net'
const BareHosts = [BaseDomain, 'www.' + BaseDomain, 'dev.' + BaseDomain]

export function defaultTenantSlug(search: string): string {
  const match = /[?&]tenant=([^&]*)/.exec(search || '')
  const slug = match ? decodeURIComponent(match[1]).toLowerCase() : ''
  return slug || 'first'
}

export function showTenantField(hostname: string): boolean {
  const host = (hostname || '').toLowerCase().split(':')[0]
  return BareHosts.indexOf(host) === -1
}



// WEBPACK FOOTER //
// ./src/app/config/tenant.util.ts